import { useState, type FormEvent } from "react";
import { useTranslation } from "react-i18next";
import { useLogin } from "../api/queries.js";

export function Login() {
  const { t } = useTranslation();
  const login = useLogin();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setErr(null);
    try {
      await login.mutateAsync({ email: email.trim().toLowerCase(), password });
    } catch {
      setErr(t("login.error"));
    }
  }

  return (
    <div className="login-wrap">
      <div className="sun-badge" aria-hidden>
        <svg
          width="38"
          height="38"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="4" />
          <path d="M12 3v1.5M12 19.5V21M5 5l1 1M18 18l1 1M3 12h1.5M19.5 12H21M5 19l1-1M18 6l1-1" />
        </svg>
      </div>
      <h1 className="brand">Sundial</h1>
      <form
        className="card"
        onSubmit={submit}
        style={{ maxWidth: 360, width: "100%", display: "flex", flexDirection: "column", gap: 14 }}
      >
        <h2 style={{ margin: 0 }}>{t("login.title")}</h2>
        <label className="field">
          <span>{t("login.email")}</span>
          <input className="input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
        </label>
        <label className="field">
          <span>{t("login.password")}</span>
          <input className="input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        {err && (
          <div className="err" role="alert">
            ⚠ {err}
          </div>
        )}
        <button
          className="btn primary"
          type="submit"
          disabled={login.isPending}
          style={{ width: "100%", marginTop: 4 }}
        >
          {t("login.submit")}
        </button>
      </form>
    </div>
  );
}
